var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SchoolConfirm.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-f1785ddc!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SchoolConfirm.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/lecturer/event/confirm/SchoolConfirm.vue
// module id = 303
// module chunks = 1